<template>
  <v-col cols="12" sm="12" md="12" class="mx-auto background">
    <v-row justify="center" align="center">
      <div style="width: 90%; font-size: 18px; font-weight: bold" class="py-4">
        <v-col>
          <v-row justify="center">
            <v-col cols="3"> </v-col>
            <v-col cols="6"
              ><v-row justify="center">
                <h2 v-if="suspend" class="my-6">Suspend User</h2>
                <h2 v-if="!suspend" class="my-6">Unsuspend User</h2>
              </v-row>
            </v-col>
            <v-col cols="3"
              ><v-row v-if="suspend == true" justify="end">
                <v-icon
                  @click="goToSettings()"
                  style="cursor: pointer"
                  class="my-6"
                  color="black"
                  >mdi-cogs</v-icon
                >
              </v-row>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-select
              v-if="suspend == true"
              :items="reasons"
              v-model="sortBy"
              solo
              border
              color="black"
              placeholder="Block Reason"
              variant="outlined"
            ></v-select>
          </v-row>
          <v-row justify="center" v-if="sortBy === 'Other'">
            <v-textarea
              v-model="message"
              solo
              outlined
              placeholder="Why are you suspending this user?"
              class="px-4"
            >
            </v-textarea>
          </v-row>
          <v-row justify="center">
            <v-btn class="mx-2 cancel-btn" @click="$emit('close')">
              Cancel
            </v-btn>
            <v-btn
              v-if="
                (sortBy != 'Other' && sortBy) ||
                (sortBy == 'Other' && message) ||
                !suspend
              "
              class="white--text mx-2 save-btn"
              @click="emitValue()"
            >
              Save
            </v-btn>
          </v-row>
        </v-col>
      </div>
    </v-row>
  </v-col>
</template>

<script>
import Navbar from "@/components/Navbar";
import {
  collection,
  getDocs,
  getFirestore,
  where,
  setDoc,
  doc,
  query,
} from "firebase/firestore";
import { firebaseApp } from "../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  name: "App",
  components: { Navbar },
  methods: {
    // Method that checks if the block reason is other & assigns the custom message
    emitValue() {
      let tempValue = this.sortBy;

      if (tempValue == "Other") {
        tempValue = this.message;
      }

      this.$emit("messageSaved", tempValue);
    },
    goToSettings() {
      this.$emit("goToSettings");
    },
    // Method to fetch all block reasons
    async getReasons() {
      let q = query(collection(db, "ban_reasons"));

      let tempReasons = [];

      const querySnapshot = await getDocs(q);
      await querySnapshot.forEach((doc) => {
        let tempReason = doc.data();

        tempReasons.push(tempReason);
      });

      this.reasons = tempReasons[0].reasonList;
    },
  },
  data() {
    return {
      message: false,
      sortBy: null,
      message: "",
      keys1: [
        "Spamming Alerts",
        "Inappropriate language",
        "Racial remarks",
        "Sexual content",
        "Other",
      ],
      reasons: [],
    };
  },
  created() {
    this.getReasons();
  },
  props: {
    suspend: true,
  },
};
</script>

<style scoped>
.background {
  background-color: white;
  width: 500px;
}

.cancel-btn {
  box-shadow: 0px 0px 0px 1px black;
  border-radius: 20px;
  width: 40%;
}

.save-btn {
  border-radius: 20px;
  width: 40%;
  background: linear-gradient(
    rgba(34, 193, 195, 1) 0%,
    rgba(0,129,128,255) 100%
  );
}
</style>